module.exports = __webpack_public_path__ + "img/_xy_.7b6d4b55.svg";